import logger from '../utils/rbmc.logger';
import cookieUtils from '../utils/rbmc.cookie-utils';
import historyService from '../utils/rbmc.historyService';
import plp from './rbmc.plp-services';
import facets from './rbmc.facets';
import spinner from '../utils/rbmc.spinner';

// functionality backported from angularJS
const facetSelection = {
    queryUrl:                     null,
    searchTerm:                   null,
    currentSelection:             null,
    actualSortingCode:            null,
    removePriceSliderUrl:         null,
    initFacet(val) {
        this.queryUrl         = val.queryUrl;
        this.searchTerm       = val.searchTerm;
        this.currentSelection = val.currentQuery;
        this.navigatedFromSubshop = !!new URL(window.location.href).searchParams.get('subshop');
        if(this.navigatedFromSubshop) {
            $(".search-component__switch-wrapper").removeClass('d-none');
            $('.checkbox-switch').prop('checked', false);
        }
    },
    handleNewLocation(newUrl, state) {
        if (this.startsWith(newUrl, this.queryUrl)) {
            // the new URL somehow belongs to us
            if (newUrl.indexOf('fq=') !== -1) {
                // the URL can be loaded as a fragment
                if (newUrl.indexOf('&type=fragment') === -1) {
                    // load the URL as a fragment
                    this.loadNow(newUrl + '&type=fragment');
                } else {
                    // the URL already contains the fragment type
                    // this should not happen as the address bar should always contain loadable URLs
                    // load it anyway ¯\_(ツ)_/¯
                    this.loadNow(newUrl);
                }
            } else {
                // no FQ, whole page load - bye!
                window.location.href = newUrl;
            }
        } else {
            // do nothing? If the URL isn't ours, we don't touch it - right?
        }
        // end here \o/

        // maybe this is the right place to write this down:
        //    Ceterum censeo JavaScriptum esse delendam
    },
    startsWith(haystack, needle) {
        return haystack.indexOf(needle) === 0;
    },
    getCurrentURL() {
        return this.getUrlFromLocation(document.location);
    },
    getUrlFromLocation(location) {
        return location.pathname + location.search + location.hash;
    },
    handlePriceSliderBreadCrumbs: function (queryPart) {
        let slider = $('#range-slider');
        logger.log('Found priceSlider -> handle lower and upper bound breadcrumb');
        if (queryPart.indexOf('lowerBound') >= 0) {
            let to = slider.data('to');
            if (to === slider.data('max')) {
                to = '*';
            }
            this.setPriceSliderParams("*", to);
        } else {
            let from = slider.data('from');
            if (from === slider.data('min')) {
                from = '*';
            }
            this.setPriceSliderParams(from, "*");
        }
    }, replaceInCurrentSelection(queryPart) {
        // they can be equal -> clear all
        if (this.currentSelection === queryPart) {
            logger.log('Clear query.');
            this.currentSelection = '';
        } else if (queryPart.indexOf('priceSlider') >= 0) {
            this.handlePriceSliderBreadCrumbs(queryPart);
        }
        // the query can be inside the current selection - then it must be followed by a colon -> remove it
        else if (this.currentSelection.indexOf(queryPart + ':') >= 0) {
            logger.log('Remove ' + queryPart + ' from query.');
            this.currentSelection = this.currentSelection.replace(queryPart + ':', ':');
        }
        // the query can be at the end -> remove it
        else if (this.currentSelection.length > 0 &&
                this.currentSelection.lastIndexOf(queryPart) > 0 &&
                this.currentSelection.lastIndexOf(queryPart) === (this.currentSelection.length - queryPart.length)) {
            logger.log('Remove ' + queryPart + ' from the end of the query.');
            let end               = this.currentSelection.length - queryPart.length;
            this.currentSelection = this.currentSelection.substring(0, end);
        }
        // add it
        else {
            logger.log('Add ' + queryPart + ' to query.');
            this.currentSelection = this.currentSelection + queryPart;
        }
    },
    changeAndLoadURL(url, callback) {
        historyService.pushState({oldUrl: document.location.href}, url);
        this.loadNow(url + '&type=fragment', callback);
    },
    loadNow(url, callback) {
        // TODO: remove this function tunnel
        // TODO: lock screen to prevent multiple submits. Unlock after response received
        this.loadProducts(url, callback);
    },
    getURL() {
        let url = null;
        if (this.currentSelection === '') {
            url = this.queryUrl + '?fq=' + this.searchTerm + this.getSubshopSelection();
        } else {
            url = this.queryUrl + '?fq=' + encodeURIComponent(this.currentSelection) + '&q=' + encodeURIComponent(this.searchTerm)
                    + this.getSubshopSelection();
        }
        return url;
    },
    loadProducts(url, callback) {
        spinner.spinnerVisibility(true);
        $('#rb-spinner').css({
            'z-index': 1100
        });
        plp.fetchFragment(url)
           .then((data) => {
                       plp.replaceHeadline(data);
                       plp.replaceFilterBar(data);
                       plp.replaceFacets(data);
                       // FIXME
                       if (this.currentSelection === '') {
                           logger.log('restore the wrong state of currentSelection');
                           this.currentSelection = $(data).filter('#plp__fragment__facets').data('currentQuery');
                       }
                       plp.exchangeProducts(data);
                       plp.replacePagination(data);
                       plp.addAppliedFacetsDesktop();
                       plp.addAppliedFacetsMobile();
                       facetSelection.bindHandlerHack();
                       plp.addOverflowIndicator();
                       this.bindFacetScrollEvent();
                       if (callback && typeof (callback) === typeof (Function)) {
                           logger.log('execute some callback function');
                           callback();
                       }
                   }, (jqXHR, textStatus) => {
                       logger.error(`loadProducts failed: ${textStatus}`);
                   }
           ).always(() => {
            spinner.spinnerVisibility(false);
            $('#rb-spinner').css({
                'z-index': ''
            });
        });
    },
    getSubshopSelection() {
        let subShop      = cookieUtils.getFirstCookieValue('subShop');
        const checkbox = $('.checkbox-switch');
        let globalSearchActive =  checkbox ? checkbox.prop('checked') : true;

        // global search is activated (see searchpage). Don't add subshop to the query
        if (globalSearchActive) {
            logger.log(`global search is activated`);
            return '';
        }else{
            logger.log(`subshop detected ${subShop}`);
            return '&subshop=' + subShop;
        }
    },
    getSortURL(sortCode) {
        this.actualSortingCode = sortCode;
        return this.getURL() + this.getSortString(sortCode);
    },
    getSortString(sortCode) {
        return '&sort=' + sortCode;
    },
    getPriceSliderUrl(priceFrom, priceTo) {
        let queryString = ":" + this.actualSortingCode + ":priceFrom:" + priceFrom + ":priceTo:" + priceTo;

        return '?fq=' + encodeURIComponent(queryString);
    },
    setPriceSliderParams(priceFrom, priceTo) {
        this.currentSelection = this.currentSelection.replace(/:priceTo:[0-9*]+/, '');
        this.currentSelection = this.currentSelection.replace(/:priceFrom:[0-9*]+/, '');
        this.replaceInCurrentSelection(":priceFrom:" + priceFrom);
        this.replaceInCurrentSelection(":priceTo:" + priceTo);
    },
    handleFacetSelection(queryPart, changeContent) {
        this.replaceInCurrentSelection(queryPart);
        if (changeContent === 'true') {
            this.changeAndLoadURL(this.getURL(), null);
        }
    },
    resetFacet(target, callback) {
        this.removeFacetFromCurrentSelection(target);
        this.changeAndLoadURL(this.getURL(), callback);
    },
    resetPriceSlider(callback) {
        logger.log(`Try to clear the price-slider`);
        this.currentSelection = this.currentSelection.replace(/:priceTo:[0-9]+/, '');
        this.currentSelection = this.currentSelection.replace(/:priceFrom:[0-9]+/, '');
        this.changeAndLoadURL(this.getURL(), callback);
    },
    removeFacetFromCurrentSelection(target) {
        let regex = new RegExp(`:${target}:[^&:]+`, 'g');

        logger.log(`Try to clear the facet "${target}"`);
        this.currentSelection = this.currentSelection.replace(regex, '');
    },
    bindHandlerHack() {
        // needed because multiple opening/closing of the dropdown will ignore the clear event inside the dropdown. Still a problem with IE11
        $('.js-facet__reset--hack').on('click', (evt) => {
            evt.stopPropagation();
            let dataSet = evt.currentTarget.dataset;

            this.resetFacet(dataSet.clear, null);
        });

        $('.js-facet__reset--price-hack').on('click', (evt) => {
            evt.stopPropagation();

            this.resetPriceSlider(null);
        });
    },
    bindHandler() {
        const $body = $(document.body);
        $body.on('click', '.js-facet-selection', (evt) => {
            // after several code changes (customer driven) this function has nearly the same behaviour as js-facet-selection--lazy
            // for the moment fine because sorting on mobile looks the same as it is for facets but behaviour is different (contentChange = true)
            evt.preventDefault();
            let self    = evt.currentTarget;
            let dataSet = self.dataset;

            logger.log(`Got click for ${dataSet.queryPart}`);
            if (dataSet.contentChange === 'false') {
                $(self).toggleClass('dropdown-item--active');
            } else {
                // RBMC-3451: add tracking for applied facets. Not part of userstory
            }
            this.handleFacetSelection(dataSet.queryPart, dataSet.contentChange);
        });

        $body.on('click', '.js-facet-selection--lazy', (evt) => {
            evt.preventDefault();
            $(evt.currentTarget).toggleClass('dropdown-item--active');
        });

        $body.on('click', '.js-apply-facet-selection--lazy', (evt) => {
            evt.preventDefault();
            let self        = evt.currentTarget;
            let facetValues = [];

            logger.log(`Got click for apply facet selection`);
            // before adding the new active facet item remove the old ones from the current selection
            this.removeFacetFromCurrentSelection(self.dataset.code);
            $(self).closest('.dropdown-menu--facet').find('.dropdown-item--active').each((index, element) => {
                let dataSet = element.dataset;

                facetValues.push(dataSet.facetValueGtm);
                this.handleFacetSelection(dataSet.queryPart, false);
            });
            this.changeAndLoadURL(this.getURL(), null);
        });

        $body.on('click', '.js-sort-selection', (evt) => {
            evt.preventDefault();
            let self    = evt.currentTarget;
            let dataSet = self.dataset;

            logger.log(`Got click for ${dataSet.queryPart}`);
            $(self).toggleClass('dropdown-item--active');
            $('#facet__overlay--sort').removeClass('facet__overlay--visible');

            this.changeAndLoadURL(this.getSortURL(dataSet.sortCode));
        });

        // send the facet selection to the server, fetch content and show the mobile facet overlay again
        $body.on('click', '.js-apply-facet-selection', (evt) => {
            let self        = evt.currentTarget;
            let facetValues = [];

            evt.preventDefault();
            logger.log(`Got click for apply facet selection`);
            // only facet values of the current open facet will be tracked
            // FIXME: user can select some values of a facet, close the facet without saving, select some values within another facet and now on save
            // only the values from last open facet will be tracked. But filtering respects all facets
            $(self).closest('.facet__overlay').find('.dropdown-item--active').each((index, element) => {
                let dataSet = element.dataset;

                facetValues.push(dataSet.facetValueGtm);
            });
            this.changeAndLoadURL(this.getURL(), () => {
                $('#facet__overlay--facets').addClass('facet__overlay--visible');
                $('#facet__product-count').show();
            });
        });

        // clear facets
        $body.on('click', '.js-facet-clear', (evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            logger.log(`Got click for clear all facets`);
            this.handleFacetSelection(this.currentSelection, 'true');
        });

        // close overlay and clear facets
        $body.on('click', '.js-mfacet-clear', (evt) => {
            evt.preventDefault();
            logger.log(`Got click for clear all facets on mobile`);
            facets.closeFacetOverlay();
            this.handleFacetSelection(this.currentSelection, 'false');
            this.changeAndLoadURL(this.getURL());
        });

        // clear one specified mobile facet (except price slider)
        $body.on('click', '.js-facet__reset', (evt) => {
            evt.stopPropagation();
            let dataSet = evt.currentTarget.dataset;

            this.resetFacet(dataSet.clear, () => {
                $('#facet__overlay--facets').addClass('facet__overlay--visible');
                $('#facet__product-count').show();
            });
        });

        // clear mobile price slider
        $body.on('click', '.js-facet__reset--price', (evt) => {
            evt.stopPropagation();

            this.resetPriceSlider(() => {
                $('#facet__overlay--facets').addClass('facet__overlay--visible');
                $('#facet__product-count').show();
            });
        });

        // open a subfacet section on mobile
        $body.on('click', '.js-mfacet__sub--show', (evt) => {
            evt.preventDefault();
            let self   = evt.currentTarget;
            let target = self.dataset.target;
            $(target).addClass('facet__overlay--visible');
        });

        // toggle pricefacet section on mobile
        $body.on('click', '.js-mfacet__sub--show-price', (evt) => {
            evt.preventDefault();
            let self   = evt.currentTarget;
            let target = self.dataset.target;
            $(target).addClass('facet__overlay--visible');
        });

        // close a subfacet section on mobile
        $body.on('click', '.js-mfacet__sub--hide', (evt) => {
            evt.preventDefault();
            $(evt.currentTarget).closest('.facet__overlay').removeClass('facet__overlay--visible');
        });

        // Expand to global search switch
        $body.on('click', '.checkbox-switch', (evt) => {
            const $this = $(evt.target);
            this.changeAndLoadURL(this.getURL(), null);
        });

        $(window).on('popstate', (event) => {
            let state = event.originalEvent.state;
            if (state) {
                this.handleNewLocation(this.getCurrentURL(), history.state);
            }
        });
    },
    bindFacetScrollEvent() {
        // scroll event doesn't bubbles trough DOM
        $('.dropdown-menu__scroller').on('scroll', (evt) => {
            let self = evt.currentTarget;
            //visible height + pixel scrolled = total height
            if (self.offsetHeight + self.scrollTop >= self.scrollHeight - 5) {
                $(self).parent().removeClass('dropmenu--overflown');
            } else {
                $(self).parent().addClass('dropmenu--overflown');
            }
        });
    }

};

$(() => {
    if ($('#js-facets').length) {

        const facetConfigSelector = '#js-facetconfig-selector';
        let facetConfig = document.querySelector(facetConfigSelector);

        if (facetConfig) {
            facetSelection.initFacet(facetConfig.dataset);
        } else {
            logger.log('No element found for selector ' + facetConfigSelector
                    + ', facets not initialized');
        }

        facetSelection.bindHandler();
        facetSelection.bindHandlerHack();
        plp.addAppliedFacetsDesktop();
        plp.addAppliedFacetsMobile();
        plp.addOverflowIndicator();
        facetSelection.bindFacetScrollEvent();

        // https://code.google.com/p/chromium/issues/detail?id=63040
        let state          = history.state || {};
        state.initialToken = true;
        historyService.replaceState(state, null);
    }
});

export default facetSelection;
